import React, { useEffect, useState, useContext, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../axiosInstance';
import { UserContext } from '../../UserContext';
import { usePriceContext } from '../Components/Context/PriceContext';
import './CreatorDashboard.css';
import Lottie from 'lottie-react';
import { BiLogoTelegram } from "react-icons/bi";
import animationData from '../Components/Assets/animationData.json'; 
import MapSection from './Map';
import { FlashIcon, SpecialOfferIcon, PremiumIcon, MotionCaptureIcon, HoldBabyIcon } from '../Utilities/Icon.js';

import useLogout from '../Utilities/LogoutUser.js';
import LiveChat from '../Components/Support/LiveChat';
import { LoadingMessages } from '../Utilities/LoadingMessages.jsx';
import Header from '../Components/Header/Header';
import { ReactComponent as ToolboxIcon } from '../Components/Assets/toolbox.svg';
import { FaBell } from "react-icons/fa";
import labIcon from '../Components/Assets/lab.svg';
import { v4 as uuidv4 } from 'uuid';
import { formatDate } from '../Utilities/FormatDate.js';
import { DisclaimerPopup } from '../Utilities/DisclaimerPopup.js';
import Submissions from '../Components/Submissions/Submissions.jsx';


const API_URL = process.env.REACT_APP_API_URL;

const CreatorDashboard = ({sdkLoaded}) => {
  
  const {getToken, user, isGuest} = useContext(UserContext);
  const [setBadgeId] = useState("");
  const location = useLocation();

  const [preview, setPreview] = useState(() => {
    return location.state?.preview === true;
  })
  const [usingMockData, setUsingMockData] = useState(false);
  
  const [alertMessage, setAlertMessage] = useState({
    type: 'info',
    text: 'Supporter Pass - Invalid or Unverified'
  });

  
  const [setIsPasted] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [downloadRequested, setDownloadRequested] = useState(false);
  const [isUnlocked, setIsUnlocked]= useState(false);
  const [downloadCount, setDownloadCount] = useState(0);
  const [searchResults, setSearchResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('featured');
  const [animationTimeout, setAnimationTimeout] = useState(null);
  const [showShareModal, setShowShareModal] = useState(false);
  const [pendingDownloadAsset, setPendingDownloadAsset] = useState(null);
  const [activeSection, setActiveSection] = useState('featured');
  const [supportServices, setSupportServices] = useState(false); 
  const [chatWindowVisible, setChatWindowVisible] = useState(false);
  const { paymentData, setPaymentData, 
      paymentSuccess, 
      activeMessageId, setActiveMessageId,
      setActiveBalanceDue,
      setConfirmation,
      setRedirectOptions,
      setRedirectDashboard} = usePriceContext();
   
  const [showInput, setShowInput] = useState(false);
  
  const [email, setEmail] = useState("");
  const logoutUser = useLogout();
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode !== null) {
      return savedMode === 'true';
    }
    return false; // default light mode
  });

  
  const [content, setContent] = useState({
    featured: {
      data: null,
      loading: true,
      error: null
    },
    flash: {
      data: null,
      loading: true,
      error: null
    },
    premium: {
      data: null,
      loading: true,
      error: null
    },
    related: {
      data: [],
      loading: true,
      error: null
    }
  });

  const [setVoteCounts] = useState({
    approve: 0,
    improve: 0,
    favorite: 0
  });

  const isPendingSubmission = (slug) => {
    return slug && slug.match(/^submission-\d{2}[A-Z]{3}\d{2}-B-[A-Z0-9]{12}$/);
  };

  const isFeaturedRelease = (slug) => {
    return slug && slug.match(/^featured-release-\d{2}[A-Z]{3}\d{2}-B-[A-Z0-9]{12}$/);
  };

  const generateMockContent = (type) => {
    const dateStr = new Date().toISOString().split('T')[0].replace(/-/g, '');
    const randomId = Math.random().toString(36).substring(2, 10).toUpperCase();
    
    const baseContent = {
      id: `mock_${type}_${randomId}`,
      type: type,
      slug: `${type}-release-${dateStr}-B-${randomId}`,
      version: (Math.random() * 5).toFixed(1),
      fileSize: `${Math.floor(Math.random() * 500) + 50} MB`,
      downloads: Math.floor(Math.random() * 1000),
      downloadUrl: "#",
      releaseDate: new Date(Date.now() - Math.floor(Math.random() * 30 * 24 * 60 * 60 * 1000)),
      badgeRequirement: ["NONE", "DIAMOND", "FOUNDER"][Math.floor(Math.random() * 3)],
      status: "PUBLISHED",
      name: "",
      description: "",
      thumbnailUrl: "",
      category: "",
      utility: ""
    };

    const typeOverrides = {
      featured: {
        name: "Epic Fantasy Sound Pack",
        description: "Immerse yourself in this comprehensive collection of fantasy-themed audio assets...",
        thumbnailUrl: "https://via.placeholder.com/400x225/6a2c7e/ffffff?text=Featured+Content",
        category: "Sound Effects",
        utility: "Game Audio"
      },
      flash: {
        name: "Limited Time Assets",
        description: "Special edition content pack",
        thumbnailUrl: "https://via.placeholder.com/400x225/2c6a7e/ffffff?text=Flash+Content",
        category: "UI Assets",
        utility: "Interface Design"
      },
      premium: {
        name: "Exclusive Mod Pack",
        description: "High-quality game modifications",
        thumbnailUrl: "https://via.placeholder.com/400x225/6a7e2c/ffffff?text=Premium+Content",
        category: "Game Mods",
        utility: "Game Enhancement"
      }
    };

    if (type === 'related') {
      return [
        {
          ...baseContent,
          id: `mock_related_1`,
          type: "premium",
          name: "6 Emotional States",
          thumbnailUrl: "https://mods.contranormdigital.com/images/emotions_icons.png?v=" + Date.now(),
          version: "1.2",
          downloads: 245
        },
        {
          ...baseContent,
          id: `mock_related_2`,
          type: "flash",
          name: "Neon UI Pack",
          thumbnailUrl: "https://via.placeholder.com/150/2c6a7e/ffffff?text=Flash",
          version: "2.0",
          downloads: 189
        }
      ];
    }

    return { ...baseContent, ...(typeOverrides[type] || {}) };
  };
  
  

 const fetchContent = async (type) => {
  if (isGuest()) {
    setAlertMessage({
        type: 'error',
        text: 'Failed to load content'});
    return generateMockContent(type); // optional: return mock content for UI
  }

  try {
    const response = await axiosInstance.post(
      `${API_URL}/api/download/content/${type}`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${getToken()}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: true
      }
    );

    if (Array.isArray(response.data) && response.data.length === 0) {
      console.log(`No ${type} content found, using mock data`);
      setUsingMockData(true);
      return generateMockContent(type);
    }

    return response.data;

    } catch (error) {
      console.error('Failed to fetch content:', {
        error: error.message,
        url: `${API_URL}/api/download/content/${type}`,
        status: error.response?.status
      });

      setUsingMockData(true);
      return generateMockContent(type);
    }
  };

  const initializeDashboard = async () => {
    setLoading(true);
    
    setAlertMessage({
      type: 'info',
      text: 'Loading content...'
    });

    try {
      const [featured, flash, premium, related] = await Promise.all([
        fetchContent('featured'),
        fetchContent('flash'),
        fetchContent('premium'),
        fetchContent('related')
      ]);

      setContent({
        featured: { 
          data: featured, 
          loading: false, 
          error: null 
        },
        flash: { 
          data: flash, 
          loading: false, 
          error: null 
        },
        premium: { 
          data: premium, 
          loading: false, 
          error: null 
        },
        related: { 
          data: Array.isArray(related) ? related : [related], 
          loading: false, 
          error: null 
        }
      });

      // Update alert if any content type is using mock data
      const usingMock = [featured, flash, premium, related].some(item => 
        item?.id?.includes('mock_')
      );
      
      if (usingMock) {
        setUsingMockData(true);
        setAlertMessage({
          type: 'demo',
          text: (
            <>
              Supporter Pass Required
            </>
          )
        });


        
      } else {
        setAlertMessage({
          type: 'success',
          text: 'Content Loaded Successfully'
        });
        setUsingMockData(false);
      }

    } catch (error) {
      console.error('Dashboard initialization failed:', error);
      setAlertMessage({
        type: 'error',
        text: 'Failed to Load Content'
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (preview) {
      initializeDashboard();
    }
  }, [preview]);
  const isValidToken = useCallback(() => {
    const token = JSON.parse(localStorage.getItem('chat3CXToken'));
    const today = formatDate();
    return token && token.date === today;
  }, []);

  const [showRoboAnimation, setShowRoboAnimation] = useState(false);
    const [hasSeenRoboAnimation, setHasSeenRoboAnimation] = useState(false);
    const [roboTriggerCount, setRoboTriggerCount] = useState(null);

    const roboMessages = {
        1: `Can't find what you're looking for? Submit a ticket to request notification when updated versions are available.`,
        10: `Submit a support ticket to request an asset.`
    };

  

   
  // Save a new token upon successful payment
  useEffect(() => {
     if (isGuest()) {
       setAlertMessage({
        type: 'error',
        text: 'Failed to Load Content'});
      return; // optional: return mock content for UI
    }
    if (supportServices) {
      // If support is enabled, ensure token exists and is valid
      const today = formatDate();
      const token = JSON.parse(localStorage.getItem('chat3CXToken'));
      
      if (!token || token.date !== today) {
        // Create/renew token if missing or expired
        const newToken = {
          messageId: `support_enabled_${Date.now()}`,
          date: today
        };
        localStorage.setItem('chat3CXToken', JSON.stringify(newToken));
      }
      return;
    }
    if (paymentSuccess && paymentData.messageId && paymentData.messageId === activeMessageId) {
      const today = formatDate();
      const token = {
        messageId: paymentData.messageId, // includes email + date + uuid4
        date: today
      };
      localStorage.setItem('chat3CXToken', JSON.stringify(token));
    }
  }, [paymentSuccess, paymentData, activeMessageId, supportServices]);
  
  // Remove old token if date doesn't match
  const purgeOldToken = () => {
    if (supportServices) return;
    const token = JSON.parse(localStorage.getItem('chat3CXToken'));
    const today = formatDate();
    if (token && token.date !== today) {
      localStorage.removeItem('chat3CXToken');
    }
  };
  
  
  useEffect(() => {
    const getSupportStatus = async () => {
       if (isGuest()) {
         setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'}); 
        return; // optional: return mock content for UI
      }
      try {
        const response = await axiosInstance.get(`/users/support-services/${user.email}`);
        const data = response.data;
        setSupportServices(data.support);
        if (data.support) {
        const today = formatDate();
        const token = JSON.parse(localStorage.getItem('chat3CXToken'));
        
        if (!token || token.date !== today) {
          const newToken = {
            messageId: `support_enabled_${Date.now()}`,
            date: today
          };
          localStorage.setItem('chat3CXToken', JSON.stringify(newToken));
        }
      }
      
      console.log("LiveChat mounted. Active Plan?", data.support); 
        
      } catch (error) {
        console.error('Error fetching support status:', error);
      }
    };
    purgeOldToken();
    getSupportStatus();
  }, [user.email]);

  useEffect(() => {
  // Only proceed if support is disabled AND no valid token
    if (supportServices === true || isValidToken()) {
      console.log(supportServices ? "Active Support Plan - Payment not required" : "Valid Token - Payment not required");
      return;
    }
    if (!chatWindowVisible || supportServices || isValidToken()) return;
      let lastTriggerTime = 0;
    
      const tryTrigger = () => {
        const now = Date.now();
        if (now - lastTriggerTime < 4000 || paymentSuccess) return;
    
        lastTriggerTime = now;
    
        console.log("Client message detected. Waiting 15s...");
    
        setTimeout(() => {
          if (!paymentSuccess) {
            const uuid = uuidv4().slice(0, 4);
            const date = formatDate();
            const messageId = `${date}_${user.email}_${uuid}`;
    
            console.log("Triggering payment modal.");
            console.log("Active message ID:", messageId);
    
            setActiveMessageId(messageId);
            setActiveBalanceDue(9.99);
    
            const paymentObj = {
              amount: 9.99,
              numericAmount: 9.99,
              messageId,
            };
            console.log("Payment data:", paymentObj);
    
            setPaymentData(paymentObj);
            setConfirmation(true);
            setRedirectOptions(true); 
          }
        }, 5000);
      
    };
  
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            console.log("New node added:", node);
  
            // Check if the added node is or contains a client message bubble
            const clientBubble =
              node.classList.contains('msg_bubble_client_s1i7p') ||
              node.querySelector?.('.msg_bubble_client_s1i7p');
  
            if (clientBubble) {
              console.log("Client message bubble detected:", node);
              tryTrigger();
            }
          }
        });
      }
    });
  
    const interval = setInterval(() => {
      const widget = document.querySelector('#wp-live-chat-by-3CX');
      const shadowRoot = widget?.shadowRoot;
      if (!shadowRoot) return;
  
      // Primary target
      const container = shadowRoot.querySelector('.root_sT5qE');
      // Backup/fallback target for debugging
      const fallbackTarget =
        shadowRoot.querySelector('.chatContainer') || shadowRoot;
  
      if (container || fallbackTarget) {
        observer.observe(container || fallbackTarget, {
          childList: true,
          subtree: true,
        });
  
        console.log(
          `Observer attached to ${container ? '.root_sT5qE' : 'fallback target'}`
        );
        clearInterval(interval);
      }
    }, 1000);
  
    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, [supportServices, user.email, paymentSuccess, chatWindowVisible,  isValidToken]);

  useEffect(() => {
      // Reset redirect flag when arriving at support services
        setRedirectDashboard(false);
   }, []);

  
  
  useEffect(() => {
    document.documentElement.classList.toggle('dark-mode', darkMode);
    localStorage.setItem('darkMode', String(darkMode));
  }, [darkMode]);

  const triggerRobo = (triggerNumber) => {
    // If they've already seen it once and you don't want repeat
    if (hasSeenRoboAnimation && triggerNumber === 1) return;

    setRoboTriggerCount(triggerNumber);
    setShowRoboAnimation(true);
  };
  const handleSearch = async (e) => {
     if (isGuest()) {
         setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'});  
      return; // optional: return mock content for UI
    }
    e.preventDefault();
    if (!searchQuery.trim()) return;

    try {
      const response = await axiosInstance.get(
        `${API_URL}/api/download/search?query=${searchQuery}`
      );

      const results = response.data || [];
      setSearchResults(results);
      setActiveTab('search');

      // 👇 Trigger robo if no results
      if (results.length === 0) {
        triggerRobo(1);
      }

    } catch (error) {
      console.error('Search error:', error);

      setSearchResults([]);
      setActiveTab('search');

      // 👇 Trigger robo on error too
      triggerRobo(1);
    }
  };
  useEffect(() => {
          const hasSeen = localStorage.getItem('hasSeenRoboAnimation');
          if (hasSeen) {
              setHasSeenRoboAnimation(false);
          }
      }, []);
  const handleCloseRoboAnimation = () => {
    setShowRoboAnimation(false);

    if (roboTriggerCount === 10) {
      setHasSeenRoboAnimation(true);
      localStorage.setItem('hasSeenRoboAnimation', 'true');
    }

    if (animationTimeout) {
        clearTimeout(animationTimeout);
    }
  };

  const handleVote = async (itemId, voteType) => {
     if (isGuest()) {
      setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'}); 
      return; // optional: return mock content for UI
    }
    try {
      const response = await axiosInstance.post(
        `${API_URL}/upload/submissions/register-vote/${voteType}`,
        {
          itemId,
          current: user.subscriptionId
        }
      );
      setVoteCounts(response.data);
      return response.data;
    } catch (error) {
      console.error(`${voteType} error:`, error);
      throw error;
    }
  };
  
  const handleImprove = async (itemId) => {
     if (isGuest()) {
      setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'}); 
      return; // optional: return mock content for UI
    }
    try {
      await handleVote(itemId, 'improve');
    } catch (error) {
      console.error('Improve error:', error);
    }
  };

  const handleApprove = async (itemId) => {
    if (isGuest()) {
      setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'}); 
      return;
    }
    try {
      await handleVote(itemId, 'approve');
    } catch (error) {
      console.error('Approve error:', error);
    }
  };

  const handleFavorite = async (itemId) => {
     if (isGuest()) {
      setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'});  
      return; // optional: return mock content for UI
    }
    try {
      await handleVote(itemId, 'favorite');
    } catch (error) {
      console.error('Favorite error:', error);
    }
  };

  const handleUnlockRequest = (event) => {
     if (isGuest()) {
       setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'}); 
      return; // optional: return mock content for UI
    }
    if (event && event.preventDefault) event.preventDefault();
    setIsUnlocked(true);
  };

  const handleDownloadClick = (event) => {
    if (event?.preventDefault) event.preventDefault();
     if (isGuest()) {
       setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'}); 
      return; // optional: return mock content for UI
    }
    

    let currentContent;
    if (activeSection === 'flash') {
      currentContent = content.flash.data;
    } else if (activeSection === 'premium') {
      currentContent = content.premium.data;
    } else if (activeSection === 'special') {
      currentContent = content.special.data;
    } else {
      currentContent = content.featured.data;
    }

    const disclaimerTypes = ['premium', 'featured', 'special', 'flash'];
    
    if (currentContent?.type && disclaimerTypes.includes(currentContent.type)) {
      setShowDisclaimer(true);
    } else {
      handleDownload();
    }
  };

  const handleAgree = (event) => {
     if (isGuest()) {
       setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'});  
      return; // optional: return mock content for UI
    }
    if (event?.preventDefault) event.preventDefault();
    
    if (pendingDownloadAsset) {
      window.open(pendingDownloadAsset.downloadUrl, '_blank');
      setPendingDownloadAsset(null);
    } else {
      handleUnlockRequest();
      setDownloadRequested(true);
      handleDownload();
    }
    
    setShowDisclaimer(false);
  };

  const handleDisagree = () => {
    setShowDisclaimer(false);
  };

  const handleDownload = async () => {
     if (isGuest()) {
       setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'});  
      return; // optional: return mock content for UI
    }
    // 1. Validate content availability
    if (!content.featured.data?.slug || !content.featured.data?.type) {
      setAlertMessage({
        type: 'error',
        text: 'Download Not Available'
      });
      return;
    }

    // 2. Handle mock/demo mode
    if (usingMockData) {
      setDownloadCount(prev => prev + 1);
      setAlertMessage({
          type: 'demo',
          text: (
            <>
              Badge Required
            </>
          )
        });
      return;
    }

    try {
      // 3. Verify supporter status (only in live mode)
      const verification = await axiosInstance.post(
        `${API_URL}/users/verify-user-status`,
        { 
          email: user?.email || JSON.parse(localStorage.getItem('user'))?.email,
          timestamp: Date.now()
        },
        { timeout: 5000 }
      );

      // 4. Process verification response
      if (!verification.data?.active) {
        throw new Error('Active supporter pass required');
      }

      const currentBadgeId = verification.data.badgeId;
      setBadgeId(currentBadgeId);
      setIsUnlocked(true);

      // 5. Execute download
      const downloadEndpoint = `${API_URL}/api/download/${content.featured.data.type}:${content.featured.data.slug}`;
      const response = await axiosInstance.post(
        downloadEndpoint,
        { badgeId: currentBadgeId },
        { responseType: 'blob' }
      );

      // 6. Process download response
      if (!(response.data instanceof Blob)) {
        throw new Error('Invalid file format received');
      }

      // 7. Create and trigger download
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${content.featured.data.slug}.zip`);
      document.body.appendChild(link);
      link.click();

      // 8. Update UI and clean up
      setDownloadCount(prev => prev + 1);
      setAlertMessage({
        type: 'success',
        text: `Download started | Badge ID: ${currentBadgeId}`
      });

      // 9. Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

    } catch (error) {
      console.error('Download error:', error);
      
      setAlertMessage({
        type: 'error',
        text: error.message.includes('supporter pass') 
          ? 'Active supporter pass required' 
          : `Download failed: ${error.message}`
      });

      setBadgeId("");
      setIsUnlocked(false);
    }
  };

     

  // Add this useEffect to handle session timeouts
  useEffect(() => {
     if (isGuest()) {
      setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'}); 
      return; // optional: return mock content for UI
    }
    const checkSession = setInterval(async () => {
      try {
        const response = await axiosInstance.post(
          `${API_URL}/users/verify-user-status`,
          { email: user?.email || JSON.parse(localStorage.getItem('user'))?.email },
          { timeout: 3000 }
        );
        
        if (!response.data?.active) {
          setIsUnlocked(false);
          setAlertMessage({
            type: 'error',
            text: 'Session Expired.'
          });
        }
      } catch (error) {
        console.error('Session Check Failed:', error);
      }
    }, 300000); // Check every 5 minutes

    return () => clearInterval(checkSession);
  }, [user]);

   const handleActiveTab = (tab) => {
     
    setActiveTab(tab);
    setAlertMessage(''); // This clears the alert message when tab changes
  };

  if (loading) {
    return (
      <div className="creative-loading">
        <LoadingMessages />
      </div>
    );
  }

  if (!content.featured.data && !usingMockData) {
    return (
      <div className="creative-loading">
        <LoadingMessages />
      </div>
    );
  }
  
  const handleEmailChange = (e) => {
    setEmail(e.target.value.toLowerCase());
  };
  const handleEmailPaste = (e) => {
    e.preventDefault(); 
    setIsPasted(true);
    alert('Please type your primary email address.');

    // Disable autofill dynamically
    setTimeout(() => {
      e.target.setAttribute("autocomplete", "off");
    }, 1000);
  };
  const handleNotifyMe = async (e) => {
    e.preventDefault(); // prevent form submit for everyone

    if (isGuest()) {
      setAlertMessage({
        type: 'error',
        text: 'Signup/Login Required'});  
      return; // exit early
    }

    setLoading(true);

    try {
      console.log("Collected email:", email);
      setShowInput(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className='creative-dashboard-page'>
      <div className={`creative-dashboard-container ${darkMode ? 'dark-mode' : ''}`}>
        {showDisclaimer && (
          <DisclaimerPopup 
            onAgree={handleAgree}
            onClose={handleDisagree}
          />
        )}
        {alertMessage && (
          <a href="https://mods.contranormdigital.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <div className="alert-banner">
              <div className="alert-content">
                {!isUnlocked && <span className="lock-icon">🔒</span>}
                <span className="alert-text">{alertMessage.text}</span>
                {alertMessage.type === 'demo' && (
                  <span className="demo-badge">DEMO</span>
                )}
              </div>
            </div>

          </a>
        
        )}
        <Header 
        showNavMessage={true} user={user}
        onLogout={logoutUser}
        chatWindowVisible={chatWindowVisible}
        setChatWindowVisible={setChatWindowVisible} />
        <div className='dashboard-scroll-container'>
          
          <main className="creative-main-content">
            

            <div className="stats-overview">
              <div className="stat-card">
                <div className="stat-value">1.2K</div>
                <div className="stat-label">Total Downloads</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">87%</div>
                <div className="stat-label">Conversion Rate</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">24</div>
                <div className="stat-label">Approved Submissions</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">4.8★</div>
                <div className="stat-label">Average Rating</div>
              </div>
            </div>

            <div className="dashboard-tabs">
              <button 
                className={`tab-button ${activeTab === 'featured' ? 'active' : ''}`}
                onClick={() => handleActiveTab('featured')}>
                Featured Releases
              </button>
              <button 
                className={`tab-button ${activeTab === 'search' ? 'active' : ''}`}
                onClick={() => handleActiveTab('search')}>
                Search 
              </button>
              <button 
                className={`tab-button ${activeTab === 'submissions' ? 'active' : ''}`}
                onClick={() => handleActiveTab('submissions')}>
                Submissions
              </button>
              <button
                className={`tab-button ${activeTab === 'baby' ? 'active' : ''}`}
                onClick={() => handleActiveTab('baby')}>
                Baby Animations
              </button>
            </div>
            
            <div className="dashboard-panels">
              <>
              {activeTab === 'search' && (
                <>
                  {/* SEARCH PANEL - hidden when searching or showing results */}
                  {!hasSearched && !showRoboAnimation && (
                    <div className="panel search">
                      <div className='dashboard-hero'>
                        <h1>Redefining What's Possible</h1>
                        <p>Manage, Showcase, and Try It All!</p>
                      </div>
                      
                      <form onSubmit={handleSearch} className="hero-search">
                        <div className="search-container">
                          <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Search by title, tag, or date..."
                            className="search-input"
                          />
                          <button 
                            type="submit"
                            className="tab-button"> 
                            <i className="icon-search"></i>
                            Request Item!
                          </button>
                        </div>
                      </form>
                    </div>
                  )}

                  {/* RESULTS PANEL - shows after search, hidden when robo animation shows */}
                  {hasSearched && !showRoboAnimation && (
                    <div className="search-panel">
                      {/* RESULTS GRID */}
                      {searchResults.length > 0 && (
                        <div className="results-grid">
                          {searchResults.map((item) => (
                            <div key={item.id} className="result-card">
                              <div className="card-media">
                                <img
                                  src={item.thumbnail}
                                  alt={item.title}
                                  className="result-thumbnail"
                                />
                                <div className="card-hover">
                                  <button className="quick-view">
                                    <i className="icon-eye"></i>
                                    Quick View
                                  </button>
                                </div>
                              </div>

                              <div className="card-body">
                                <h4>{item.title}</h4>
                                <div className="card-meta">
                                  <span className="meta-date">{item.date}</span>
                                  <span className="meta-downloads">
                                    {item.downloads} downloads
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                     
                    </div>
                  )}

                  {/* ROBOT ANIMATION - shows when no results */}
                  {showRoboAnimation && (
                    <div className="popup">
                      <div className="popup-content">
                        <span 
                          className="close-btn"
                          onClick={handleCloseRoboAnimation}
                        >
                          &times;
                        </span>
                        <h1><strong>Diamond Badge Holders</strong></h1>
                        <div className="floating-robot">
                          <Lottie
                            animationData={animationData}
                            loop
                            autoplay
                            style={{
                              width: 180,
                              height: 180,
                              margin: "-40px auto -30px"
                            }}
                          />
                        </div>

                        <p>
                          {roboMessages[roboTriggerCount]}
                        </p>
                        <h1>
                          <a
                            href={`mailto:ticket@contranormdigital.com?subject=Content Request&body=Hi,%0D%0A%0D%0AI searched for "${searchQuery}" but it was not available. Please notify me when updated versions are available.%0D%0A%0D%0AThank you.`}
                            className="cta-pulse-button2"
                          >
                            <i><BiLogoTelegram /></i>
                          </a>
                        </h1>
                      </div>
                    </div>
                  )}
                </>
              )}
              {activeTab === 'baby' && (
                <div className="panel baby-feature-section">
                  <div className="baby-main-grid">  
                    {/* LEFT COLUMN - MAIN CONTENT */}
                    <div className="left-column">
                      {/* FEATURED VIDEO - LARGE */}
                      <div className="featured-module">
                        <div className="module-title">
                         
                          <h2> <i className="bi bi-star-fill"></i> Featured Animation Pack</h2>
                        </div>
                        <div className='special-divider'>
                            <div className="featured-video">
                            <i className="bi bi-play-circle-fill"></i>
                          </div>
                            
                          <div className="featured-caption">
                            <p><strong style={{ margin: '15px 0', fontSize: '0.85rem' }}>Developmental Milestones Pack</strong></p>
                            
                              <ul style={{ margin: '15px 0', paddingLeft: '20px' }}>
                                <li>Giggling, smiling, and crying with weight shifts</li>
                                <li>Grasp reflex with proper hand-object motions</li>
                                <li>Head tilting and tracking</li>
                                <li>Realistic emotional responses</li>
                                <li>Rooting, sucking & gag reflexes</li>
                              </ul>
                            <p style={{ margin: '15px 0', fontSize: '0.75rem' }} ><MotionCaptureIcon className="section-icon" /> ased on extensive infant motion capture research.
                            </p>
                            <p style={{ margin: '15px 0', fontSize: '0.75rem' }} ><HoldBabyIcon className="section-icon" /> Detailed texture maps, precision weight-painting, near-life deformation, and expressive movement.
                            </p>
                            <div className="founder-cta">
                               <h3 style={{ position: 'relative' }}>
                                  <i className="fas fa-crown"></i>
                                  <span
                                    style={{
                                      position: 'absolute',
                                      bottom: '3px',
                                      right: '4px',
                                      backgroundColor: 'purple',
                                      color: 'white',
                                      fontSize: '10px',
                                      padding: '1px 4px',
                                      border: '1px solid white',
                                      borderRadius: '5px',
                                      transform: 'translate(50%, 50%)',
                                    }}
                                  >
                                    6
                                  </span>
                                </h3>
                                <div>Badge-Holder Submission</div>
                              <p
                              style={{
                                textAlign: 'center',
                                margin: '0px 0 5px 0',
                                fontSize: '0.95em',
                              }}
                            >
                              <a
                                href="https://mods.contranormdigital.com/passes/supporter-pass-with-diamond-badge-combo/"
                                style={{
                                  color: 'var(--primary-dark)',
                                  fontWeight: 400,
                                  fontFamily: 'cursive',
                                  textDecoration: 'none',
                                  borderBottom: '1px dashed var(--accent)',
                                }}
                              >
                                <strong className="fuggles-regular">Love what we do?</strong>
                                <br />
                              </a>
                              <i className="bi bi-heart-fill" style={{ color: 'var(--accent)' }}></i>
                              <br />
                              Let everyone know with a badge.
                            </p>
                            </div>
                            
                          </div>
                          
                        </div>
                        
                          
                        <p className="featured-caption">
                            Developmental Milestones Pack — hyper-real infant interaction with 20+ animations and full body motion capture data.
                          </p>
                          {/* WHY SECTION - UNDER VIDEO */}
                      
                      </div>
                      
                        
                      
                    </div> 
                    {/* RIGHT COLUMN - STACKED SQUARES */}
                    <div className="right-column">
                        
                      {/* SQUARE 1 */}
                      <div className="square-module">
                        <div className='module-title'>
                           <h2><i class="bi bi-stars"></i> Supporter Pass</h2>
                          
                        </div>
                        <p>$5/mo – Mystery Pack + Identifier badge + exclusive Discord role and early access to new content.</p>
                        <button className="cta-button small">Get Badge</button>
                      </div>
                        
                      {/* SQUARE 2 */}
                      <div className="square-module">
                        <div className='module-title'>
                          <h2><i class="bi bi-gift"></i> Free Starter Files</h2>
                          
                        </div>
                        <p>Try basic infant interactions free. Includes 3 base animations and sample models.</p>
                        <em style={{fontSize: '1rem', marginLeft: '3px', lineHeight: '1.2'}}>
                          Starter files include original animations.</em>
                        <button className="cta-button small">Download</button>
                      </div>
                      {/* SQUARE 3 */}
                      <div className="square-module">
                        <div className='module-title'>
                          <h2><i class="bi bi-gift"></i> Free Starter Files</h2>
                          
                        </div>
                        <p>Try basic infant interactions free. Includes 3 base animations and sample models.</p>
                        <em style={{fontSize: '1rem', marginLeft: '3px', lineHeight: '1.2'}}>
                          Starter files include original animations.</em>
                        <button className="cta-button small">Download</button>
                      </div>
                      {/* SQUARE 4 */}
                      <div className="square-module">
                        <div className='module-title'>
                          <h2><i class="bi bi-gift"></i> Free Starter Files</h2>
                          
                        </div>
                        <p>Try basic infant interactions free. Includes 3 base animations and sample models.</p>
                        <em style={{fontSize: '1rem', marginLeft: '3px', lineHeight: '1.2'}}>
                          Starter files include original animations.</em>
                        <button className="cta-button small">Download</button>
                      </div>
                    </div>
                      
                   
                      
                  </div>
                  
                  <div className="why-module">
                    <div className='module-title-3d'>
                      
                      <h2> <i class="bi bi-patch-check"></i> Why Our 3D Content Stands Out</h2>
                    </div>
                    
                    <div className="why-grid">
                      <div className="why-item">
                        <h3>Technical Precision</h3>
                        <p>Proper joint weights and muscle deformation for natural movement.</p>
                      </div>
                      <div className="why-item">
                        <h3>Medical Accuracy</h3>
                        <p>Based on real developmental stages and pediatric research.</p>
                      </div>
                      <div className="why-item">
                        <h3>Customizable</h3>
                        <p>Swap meshes, textures & accessories with modular rigging.</p>
                      </div>
                    </div>
                  </div>
                      {/* BOTTOM ROW - THREE CARDS */}
                  <div className="bottom-row"> 
                    
                    <div className="bottom-card community">
                      <div className='module-title'>
                        <i class="bi bi-people-fill"></i>
                        <h2>Community Feedback</h2>
                      </div>
                      
                      <blockquote>
                        "The most realistic baby animations I've ever seen. Worth every penny for medical visualization."
                      </blockquote>
                      <p style={{color: '#666', fontSize: '0.9rem'}}>— Dr. Sarah Chen, Pediatric Animator</p>
                    </div>
                      
                      {/* ROADMAP CARD */}
                    <div className="bottom-card roadmap">
                      <div className='module-title'>
                        <i class="bi bi-map"></i>
                        <h2>Roadmap</h2>
                      </div>
                      
                      <ul>
                        <li><span style={{color: '#4CAF50'}}>✓</span> Milestones Pack (Released)</li>
                        <li><span style={{color: '#FF9800'}}>⟳</span> Nursing Pack (In Progress)</li>
                        <li><span style={{color: '#FF9800'}}>⟳</span> Sleep Animations (Coming Soon)</li>
                        <li><span style={{color: '#9E9E9E'}}>🔒</span> Emotional Expressions (Planned)</li>
                      </ul>
                    </div> 
                  </div>
                    {/* AMAZING SECTION CARD */}
                  <div className="bottom-card amazing">
                    <h2>Something Amazing Is Coming</h2>

                    <div className="countdown">
                      <div className="countdown-item">
                        <span className="countdown-number">12</span>
                        <span className="countdown-label">Days</span>
                      </div>
                      <div className="countdown-item">
                        <span className="countdown-number">04</span>
                        <span className="countdown-label">Hours</span>
                      </div>
                      <div className="countdown-item">
                        <span className="countdown-number">32</span>
                        <span className="countdown-label">Minutes</span>
                      </div>
                    </div>
                     <div style={{ position: "relative" }}>
                      {!email && (
                        <FaBell
                          size={60}
                          color="#ff10f0"
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowInput(true)}
                        />
                      )}

                      {/* Email Popup */}
                      {showInput && (
                        <div
                          style={{
                            position: "absolute",
                            top: "70px",
                            left: "0",
                            background: "white",
                            padding: "20px",
                            borderRadius: "10px",
                            boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                            width: "250px",
                          }}
                        >
                          <form onSubmit={handleNotifyMe}>
                            <input
                              type="email"
                              placeholder="Enter your email"
                              value={email}
                              onChange={handleEmailChange}
                              onPaste={handleEmailPaste}
                              required
                              
                              style={{
                                width: "100%",
                                padding: "8px",
                                marginBottom: "10px",
                              }}
                            />
                            <button
                              type="submit"
                              style={{
                                width: "100%",
                                padding: "8px",
                                backgroundColor: "#ff10f0",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            >
                              Submit
                            </button>
                          </form>
                        </div>
                      )}
                    </div>
                    
                   
                    
                  </div>
                  <div className="social-section">
                    <div className="social-links">
                      <i className="bi bi-instagram"></i>
                      <i className="bi bi-twitter-x"></i>
                      <i className="bi bi-youtube"></i>
                      <i className="bi bi-discord"></i>
                    </div>
                  </div>
                </div>
              )}


              {activeTab === 'featured' && (
                <div className="panel featured-panel">
                  
                  <div className="featured-content">
                    <div className="featured-media">
                      <div className="media-container">
                        <video 
                          controls 
                          poster={content.featured.data?.thumbnailUrl || "https://via.placeholder.com/800x450/6a2c7e/ffffff?text=Featured+Content"}
                          className="featured-video"
                        >
                          <source src="https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_1mb.mp4" type="video/mp4" />
                        </video>
                        <div className="media-badge">Featured</div>
                      </div>

                      {content.featured.data && (
                        <div className="download-card">
                          <h3>Mystery Pack Download</h3>
                          <div className="download-stats">
                            <div className="progress-container">
                              <div 
                                className="progress-bar" 
                                style={{ width: `${Math.min(100, (downloadCount / 1000) * 100)}%` }}
                              ></div>
                            </div>
                            <span className="download-count">{downloadCount} downloads</span>
                          </div>
                          <h3><FlashIcon className="section-icon" />Flash Release</h3>
                          <div className="download-stats">
                            <div className="progress-container">
                              <div 
                                className="progress-bar" 
                                style={{ width: `${Math.min(100, (downloadCount / 1000) * 100)}%` }}
                              ></div>
                            </div>
                            <span className="download-count">{downloadCount} downloads</span>
                          </div>
                          <h3><SpecialOfferIcon className="section-icon" />Limited Edition | Special Offer</h3>
                          <div className="download-stats">
                            <div className="progress-container">
                              <div 
                                className="progress-bar" 
                                style={{ width: `${Math.min(100, (downloadCount / 1000) * 100)}%` }}
                              ></div>
                            </div>
                            <span className="download-count">{downloadCount} downloads</span>
                          </div>
                          <h3><PremiumIcon className="section-icon" /> Premium Mods & Accessories</h3>
                          <div className="download-stats">
                            <div className="progress-container">
                              <div 
                                className="progress-bar" 
                                style={{ width: `${Math.min(100, (downloadCount / 1000) * 100)}%` }}
                              ></div>
                            </div>
                            <span className="download-count">{downloadCount} downloads</span>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="featured-details">
                      <div className="detail-header">
                        <h2>{content.featured.data?.name || "Epic Fantasy Sound Pack Vol. 3"}</h2>
                        <div className="release-tags">
                          <span className="tag">Latest</span>
                          <span className="tag">Version {content.featured.data?.version || "2.1"}</span>
                          <span className="tag">Popular</span>
                        </div>
                      </div>
                      
                      <div className="detail-body">
                        <p className="release-description">
                          {content.featured.data?.description}
                        </p>
                        
                        <div className="detail-meta">
                          <div className="meta-item">
                              <i className="icon-calendar"></i>
                              <span>
                                Released:{" "}
                                {content.featured.data?.releaseDate 
                                  ? formatDate(content.featured.data.releaseDate) 
                                  : formatDate("2023-11-15")}     
                              </span>
                            </div>
                            <div className="meta-item">
                              <i className="icon-file"></i>
                              <span>File size: {content.featured.data?.fileSize || "245 MB"}</span>
                            </div>
                            <div className="meta-item">
                              <i className="icon-grid"></i>
                              <span>Category: {content.featured.data?.category || "Sound Effects"}</span>
                          </div>
                        </div>
                        <div className='meta-item'>
                            <i className="icon-alert"></i>
                            <span className="small-text">{content.featured.data?.notes ||
                            "This file is a technical preview that requires user implementation.It may contain custom injections that may disrupt your systems' functionality without warning or resolve."}</span>
                          </div>
                        {isPendingSubmission(content.featured.data?.slug) ? (
                          <>
                            <button className="download-button disabled" disabled>
                              <i className="icon-download"onClick={handleDownloadClick}></i> Download Now
                            </button>
                            <div className="quick-actions">
                              <button className="action-button" onClick={() => handleImprove(content.featured.data?.id)}>
                                <i className="icon-share"></i> Improve
                              </button>
                              <button className="action-button" onClick={() => handleApprove(content.featured.data?.id)}>
                                <i className="icon-heart"></i> Approve
                              </button>
                            </div>
                          </>
                        ) : isFeaturedRelease(content.featured.data?.slug) ? (
                          <>
                            <button className={`download-button ${isUnlocked ? '' : 'disabled'}`}
                              disabled={!isUnlocked}
                              onClick={isUnlocked ? handleDownloadClick : handleUnlockRequest}
                            >
                              <h3><img src={labIcon} alt="Lab Icon" className="labIcon" /></h3> 
                            {isUnlocked ? 'Download Now' : 'Unlock with Diamond Badge'}
                            </button>
                            <div className="quick-actions">
                              <button className="action-button" onClick={() => setShowShareModal(true)}>
                                <i className="icon-share"></i> Share
                              </button>
                              <button className="action-button" onClick={() => handleFavorite(content.featured.data?.id)}>
                                <i className="icon-heart">🔥</i> Favorite
                              </button>
                            </div>
                          </>
                        ) : (
                          <button 
                            className={`download-button ${isUnlocked ? '' : 'disabled'}`}
                            onClick={(event) => {
                              if (isUnlocked) {
                                handleDownloadClick(event);
                              } else {
                                handleUnlockRequest(event);
                              }
                            }}
                            style={{
                              background: isUnlocked 
                                ? 'linear-gradient(90deg, #6a2c7e, #b4509a)' 
                                : '#cccccc',
                              cursor: isUnlocked ? 'pointer' : 'pointer'
                            }}
                          >
                            <h3><img src={labIcon} alt="Lab Icon" className="labIcon" /></h3> 
                            {isUnlocked ? 'Download Now' : 'Enter Lab With Badge'}
                          </button>
                        )}
                      </div>
                      <MapSection />
                      
                    </div>
                    
                    {showShareModal && (
                      <div className="share-modal-overlay">
                        <div className="share-modal">
                          <h3>Share Options</h3>
                          <div className="share-options">
                            <button className="share-option">
                              <i className="icon-twitter"></i> Twitter
                            </button>
                            <button className="share-option">
                              <i className="icon-facebook"></i> Facebook
                            </button>
                            <button className="share-option">
                              <i className="icon-link"></i> Copy Link
                            </button>
                          </div>
                          <button className="close-modal" onClick={() => setShowShareModal(false)}>
                            Close
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="additional-content">
                    <div className="content-section">
                      <h3><ToolboxIcon className="toolbox-icon"/>Toolbox</h3>
                      <ul className="included-items">
                        <li><a href="/policies">Terms & Conditions</a></li>
                        <li><a href="https://compliance.contranormdigital.com/">Privacy Policy</a></li>
                        <li><a href="https://mods.contranormdigital.com/fact-sheet/">Fact Sheet</a></li>
                        <li>Submission Requirements</li>
                        <li><a href="https://mods.contranormdigital.com/passes/supporter-pass-with-diamond-badge-combo/">Purchase Pass/Badge</a></li>
                      </ul>
                    </div>
                    <div className='content-section' ><h1>Preemie</h1> </div>
                    <div className='content-section' ><h1>Newborn 0-8 weeks</h1> </div>
                    <div className='content-section' ><h1>Infant 3-6 months</h1> </div>
                    <div className='content-section' ><h1>Infant 7-12 months</h1> </div>
                    <div className="content-section">
                    <h3>Related Assets</h3>
                    {content.related.loading ? (
                      <LoadingMessages />
                    ) : (
                      <div className="related-assets">
                        {content.related.data?.map((asset) => (
                          <div 
                            key={asset.id} 
                            className="related-asset"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              
                              if (asset.downloadUrl) {
                                const needsDisclaimer = ['premium', 'featured', 'special', 'flash'].includes(asset.type);
                                if (needsDisclaimer) {
                                  setShowDisclaimer(true);
                                  setPendingDownloadAsset(asset);
                                } else {
                                  window.open(asset.downloadUrl, '_blank');
                                }
                              }
                            }}
                          >
                            <div className="asset-thumbnail">
                              {asset.thumbnailUrl && (
                                <img 
                                  src={asset.thumbnailUrl} 
                                  alt={asset.name}
                                  className="asset-image"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.parentElement.querySelector('.asset-icon').style.display = 'block';
                                  }}
                                />
                              )}
                              
                              <div 
                                className="asset-icon" 
                                style={{ display: asset.thumbnailUrl ? 'none' : 'block' }}
                              >
                                {asset.type === 'premium' ? (
                                  <PremiumIcon />
                                ) : asset.type === 'flash' ? (
                                  <FlashIcon />
                                ) : (
                                  <SpecialOfferIcon />
                                )}
                              </div>
                              
                              <div className="download-overlay">
                                <i className="icon-download"></i>
                              </div>
                            </div>
                            
                            <div className="asset-info">
                              <span className="asset-name">{asset.name}</span>
                              {asset.version && <span className="asset-version">v{asset.version}</span>}
                              {asset.downloads && (
                                <span className="asset-downloads">
                                  <i className="icon-download"></i> {asset.downloads}
                                </span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                      )}
                      
                    </div>
                    
                  </div>
                  
                </div>
                
                
              )}
              </>
              

              {activeTab === 'submissions' && (
                <div className="panel submissions-panel">
                  <Submissions 
                  alertMessage = {alertMessage}
                  setAlertMessage = {setAlertMessage}
                  />
                </div>
              )}
              
            </div>
            
          </main>
          
        
        
          <button 
            className="theme-toggle"
            onClick={() => setDarkMode(!darkMode)}
            aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}>
            {darkMode ? '☀️' : '🌙'}
          </button>
                                  
          {chatWindowVisible && <LiveChat chatWindowVisible={chatWindowVisible} />}
        </div>
      </div>

    </div>
    
    
  );
};

export default CreatorDashboard;